<template>
  <div :class="computedClass">
    <main class="jade-container__main">
      <slot />
    </main>
    <aside
      v-if="$slots.aside"
      class="jade-container__aside"
    >
      <slot name="aside" />
    </aside>
  </div>
</template>
<script>
const SIZE_ENUM = {
  WIDE: 'wide',
  NARROW: 'narrow',
  FULL: 'full'
}

const ASIDE_POSITION = {
  RIGHT: 'right',
  LEFT: 'left'
}

export default {
  name: 'JadePageContainer',
  props: {
    asidePosition: {
      type: String,
      default: () => ASIDE_POSITION.RIGHT,
      validation: value => Object.values(ASIDE_POSITION).includes(value)
    },
    size: {
      type: String,
      default: () => SIZE_ENUM.FULL,
      validation: value => Object.values(SIZE_ENUM).includes(value)
    }
  },
  computed: {
    computedClass () {
      return {
        'jade-container': true,
        [`is-${this.size}`]: this.size,
        [`is-${this.asidePosition}-aside`]: this.asidePostion
      }
    }
  }
}
</script>
<style>
@import '@stone-payments/jade/css/page-container.css';
</style>
